import PropTypes from "prop-types";
import React from "react";
import {
    Header,
    Image,
    Label,
    Segment,
} from "semantic-ui-react";
import photoPlaceholder from "./placeholder.jpg";
import Counters from "./util/Counters";
import Deadline from "./util/Deadline";
import STATUS from "./util/STATUS";
import withDocumentReference from "./util/withDocumentReference";

class ContextHeader extends React.PureComponent {

    render() {
        const {
            context: c,
            onClick,
            media,
        } = this.props;
        const now = Date.now();
        const deadlines = (c.regions || [])
            .filter(it => it.when)
            .sort((a, b) => a.when - b.when);
        const futureDeadlines = deadlines
            .filter(it => it.when > now);
        const hasDeadlines = deadlines.length > 0;
        const deadlineNode = hasDeadlines && <Deadline
            ts={(futureDeadlines.length
                ? futureDeadlines[0]
                : deadlines[deadlines.length - 1]).when
            } />;
        const statusLabel = c.status === STATUS.DRAFT
            ? <Label content="draft"
                     attached="top"
                     icon="pencil"
                     className="status" />
            : c.status === STATUS.ARCHIVED
                ? <Label content="archived"
                         attached="top"
                         icon="archive"
                         className="status" />
                : undefined;
        return <Segment onClick={onClick} style={{ cursor: "pointer" }}>
            {statusLabel}
            <Header as="h2">
                {media && <Image src={(media.thumbnail && media.thumbnail.downloadURL) || photoPlaceholder} onClick={(e) => {
                    if (media.downloadURL) {
                        e.preventDefault();
                        e.stopPropagation();
                        window.open(media.downloadURL)
                    }
                }} />}
                <Header.Content>
                    {c.title}
                    <Header.Subheader>
                        {c.counters && <Counters n={c.counters} />}
                        {" "}
                        {deadlineNode}
                    </Header.Subheader>
                </Header.Content>
            </Header>
        </Segment>;
    }

}

ContextHeader.propTypes = {
    isDm: PropTypes.bool.isRequired,
    context: PropTypes.object.isRequired,
    onClick: PropTypes.func,
};

export default withDocumentReference({
    media: props => props.context.media
})(ContextHeader);



// WEBPACK FOOTER //
// ./src/ContextHeader.js